import $ from 'jquery';

const UP = 200;
const DOWN = 320;
// Code to convert select to UL
$('.wp-block-polylang-language-switcher').each(function () {
	const $select = $(this).find('select'),
		$list = $('<ul />');
	$select.find('option').each(function () {
		const newTag = replaceTag(this, 'li');
		$list.append(newTag);
	});
	//Remove the select after the values are taken
	$select.after($list).remove();

	//Append Default text to show the selected
	$(this).append('<span class="icon-globe"></span>');
	$(this).find('span');

	// On click show the UL
	$(this).on('click', 'span', function (e) {
		e.stopPropagation();
		const ul = $(this).parent().find('ul');
		if (ul.is(':visible')) ul.slideUp(UP);
		else ul.slideDown(DOWN);
	});

	// On select of list select the item
	$(this).on('click', 'li', function () {
		const langUrl = $(this).attr('value');
		window.location.href = langUrl;
	});
});

function replaceTag(origEl, tagName) {
	// New type of the tag
	const replacementTag = tagName;
	const outer = origEl.outerHTML;

	// Replace opening tag
	let regex = new RegExp('<' + origEl.tagName, 'i');
	let newTag = outer.replace(regex, '<' + replacementTag);

	// Replace closing tag
	regex = new RegExp('</' + origEl.tagName, 'i');
	newTag = newTag.replace(regex, '</' + replacementTag);

	return newTag;
}

// On click out hide the UL
$(document).on('click', function () {
	$('.wp-block-polylang-language-switcher ul').slideUp(UP);
});
